import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useState } from "react";
import { Permission } from "../../../common/security/enums";
import { AgentsImportModalForm } from "../../agent/components/forms/AgentsImportModalForm";
import ComponentWithPermission from "../../auth/components/ComponentWithPermission";
import ClientsImportForm from "../../client/components/forms/import/ClientsImportForm";
import ContractsImportForm from "../../contract/components/forms/import/ContractsImportForm";
import { ContractUpdateFilterView } from "../components/views/ContractUpdateFilterView";

export const ContractUpdateContainer = () => {
  const [clientImportFormOpen, setClientImportFormOpen] = useState<boolean>(false);
  const [agentImportFormOpen, setAgentImportFormOpen] = useState<boolean>(false);
  const [contractImportFormOpen, setContractImportFormOpen] = useState<boolean>(false);

  return (
    <ContentWrapper>
      <ContractUpdateFilterView
        onImportClientsClick={() => setClientImportFormOpen(true)}
        onImportAgentsClick={() => setAgentImportFormOpen(true)}
        onImportContractsClick={() => setContractImportFormOpen(true)}
      />

      <ComponentWithPermission permissions={[Permission.CLIENT_IMPORT]}>
        <ClientsImportForm open={clientImportFormOpen} onFormCancel={() => setClientImportFormOpen(false)} />
      </ComponentWithPermission>

      <ComponentWithPermission permissions={[Permission.AGENT_IMPORT]}>
        <AgentsImportModalForm isOpen={agentImportFormOpen} onFormCancel={() => setAgentImportFormOpen(false)} />
      </ComponentWithPermission>

      <ComponentWithPermission permissions={[Permission.CONTRACT_IMPORT]}>
        <ContractsImportForm open={contractImportFormOpen} onFormCancel={() => setContractImportFormOpen(false)} />
      </ComponentWithPermission>
    </ContentWrapper>
  );
};
